// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"325d6563","233":"325d6563","263":"325d6563","380":"325d6563","514":"325d6563"}[chunkId] + ".chunk.css";
};